import { render, staticRenderFns } from "./PanelDragButton.vue?vue&type=template&id=6b344019&"
import script from "./PanelDragButton.vue?vue&type=script&lang=ts&"
export * from "./PanelDragButton.vue?vue&type=script&lang=ts&"
import style0 from "./PanelDragButton.vue?vue&type=style&index=0&id=6b344019&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports